/* tslint:disable */
/* tslint:disable */
/**
 */
export class TicketReverse {
    from_date?: string;
    to_date?: string;
    user_id?: number;
    limit?: number;
    page?: number;
    ticket_price_id?: number;
    
}
